import * as R from 'ramda';

import type { SearchWhere } from './InflationDistributionModal';

interface IFilterItem {
    eq: string;
}

export interface IFiltersWhere {
    [key: string]: {
        or?: IFilterItem[];
    };
}

export const getWorkOrderWhereFromFilter = (filterName: string, values: string[]) => {
    if (!values?.length) {
        return { [filterName]: undefined };
    }

    return {
        [filterName]: {
            or: values.map((item: string) => ({
                eq: item,
            })),
        },
    };
};

export const getWhere = (searchString?: SearchWhere, filtersWhere?: IFiltersWhere) => {
    const stringWhere = searchString && {
        or: [
            {
                code: {
                    containsi: searchString.value,
                },
            },
            {
                name: {
                    containsi: searchString.value,
                },
            },
            {
                uerCode: {
                    containsi: searchString.value,
                },
            },
        ],
    };

    if (stringWhere && filtersWhere && !R.isEmpty(filtersWhere)) {
        return {
            and: [stringWhere, filtersWhere],
        };
    }

    if (stringWhere) {
        return stringWhere;
    }

    if (!R.isEmpty(filtersWhere)) {
        return filtersWhere;
    }

    return undefined;
};
